import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import Icon from './Icons';
import useReveal from '../../hooks/useReveal';

const CTA = () => {
  const ref = useReveal();
  return (
    <section className="pb-20 md:pb-28">
      <div ref={ref} className="container-app">
        <div className="reveal relative overflow-hidden rounded-2xl border border-accent/20 bg-accent p-8 text-surface-0 md:p-12">
          <div className="absolute -right-16 -top-24 h-64 w-64 rounded-full border-[3rem] border-surface-0/5" aria-hidden="true" />
          <div className="absolute -bottom-20 -left-10 h-52 w-52 rounded-full bg-surface-0/5 blur-2xl" aria-hidden="true" />
          <div className="relative max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[.14em] opacity-70">Следующий шаг</p>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight md:text-5xl">Запустите первый заказ сегодня.</h2>
            <p className="mt-4 max-w-xl text-sm leading-6 text-surface-0/70 md:text-base">
              Регистрация занимает несколько минут. После этого техника, заказы и история работы будут в одном месте.
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link to="/register"><Button variant="secondary" size="xl" iconRight={<Icon name="arrowRight" />}>Создать аккаунт</Button></Link>
              <Link to="/login"><Button variant="ghost" size="xl" className="text-surface-0 hover:bg-surface-0/10">Войти</Button></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
